import { jsx as _jsx } from "react/jsx-runtime";
import { AuthView } from './auth_view';
/**
 *  Styles will be inlined since these components will be rendered for PDF generation
 */
export const StudyNameWithMixPIIPreview = ({ messages, productMessages }) => {
    if (!messages) {
        return null;
    }
    return [
        _jsx(AuthView, { title: messages.value, productMessages: productMessages, isNoPIIEnabled: false }, 'study-name-mix-pii'),
    ];
};
//# sourceMappingURL=study_name_mix_pii.previews.component.js.map